/**
 * Examples:
 * 1. If we want to upload 4 files - each will send percentage: 0.25. first one will send startPoint:0, second- startPoint: 0.25, third - 0.5 etc.
 * 2. If we have 2 different api calls and we're assuming second one will take 80% of time. first will have startPoint 0, percentage: 0.2, second - startPoint: 0.2, percentage: 0.8
 * */

import {AxiosProgressEvent} from 'axios';

export function onUploadMultipleFilesProgress(
  startPoint: number, //decimal
  percentage: number, //decimal
  uploadFunc: (e: AxiosProgressEvent) => void,
) {
  return (progress: AxiosProgressEvent) => {
    uploadFunc({
      ...progress,
      total: (progress.total as number) * (1 / percentage),
      loaded: (progress.total as number) * (startPoint / percentage) + progress.loaded,
    });
  };
}
